import React from 'react';
import PropTypes from 'prop-types';
import * as S from './styles';

export default function InfoTitle({ title, children, borderColor, textColor }) {
  return (
    <S.InfoTile borderColor={borderColor} color={textColor}>
      <S.Title>{title}</S.Title>
      <S.Content>{children}</S.Content>
    </S.InfoTile>
  );
}

InfoTitle.propTypes = {
  title: PropTypes.string,
  children: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  borderColor: PropTypes.string,
  textColor: PropTypes.string,
};

InfoTitle.defaultProps = {
  title: '',
  children: '',
  borderColor: 'dark',
  textColor: 'dark',
};
